import axios from "axios";
import { __constants } from "../constants";
const BASE_URL = process.env.REACT_APP_SERVER_URL;

export const getRolesListing = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/nona-roles",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            }
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        return err.response
    }
}

export const addRoles = async (data) => {
    try {
    
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/nona-roles",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addSubAdmin >> ", err.message);
        return err.response
    }
}

export const addSubAdmin = async (data) => {
    try {
        const config = {
            method: 'POST',
            url: BASE_URL + "/v1/admin/sub-admin",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addSubAdmin >> ", err.message);
        return err.response
    }
}

export const getSubAdminsListing = async () => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + "/v1/admin/sub-admin/",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getSubAdminsListing >> ", err.message);
        return err.response
    }
}

export const editSubAdmin = async (id,data) => {
    try {
        const config = {
            method: 'PUT',
            url: BASE_URL + "/v1/admin/sub-admin/"+id,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: data
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in addSubAdmin >> ", err.message);
        return err.response
    }
}

export const getSubAdminProfileController = async (id) => {
    try {
        const config = {
            method: 'GET',
            url: BASE_URL + `/v1/admin/sub-admin/${id}`,
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in getSubAdminProfileController >> ", err.message);
        return err.response
    }
}

export const updateSubAdminProfileController = async (formdata) => {
    try {
        const config = {
            method: 'PUT',
            url: BASE_URL + "/v1/admin/edit-sub-admin-profile",
            headers: {
                'Authorization': `Bearer ${localStorage.getItem(__constants.authToken)}`,
            },
            data: formdata
        };
        const response = await axios(config);
        return response;
    } catch (err) {
        console.error("Error in updateSubAdminProfileController >> ", err.message);
        return err.response
    }
}